export var SessionStorageEnum;
(function (SessionStorageEnum) {
    SessionStorageEnum["SelectedModuleID"] = "selectedModuleID";
    SessionStorageEnum["SelectedJobID"] = "selectedJobID";
})(SessionStorageEnum || (SessionStorageEnum = {}));
